import React, { useState } from "react";
import styles from "./desktop-program.module.scss";
import DPrograms from "./DPrograms";
import DProgramListing from "./DProgramListing";
import Close from "@/SvgIcons/Close";

interface ProgramsDetails {
  categoryParentTitle: string;
  categoryTitle: string;
  programsList: Array<unknown>;
}
const DesktopProgramMenu = ({ headerHeight ,setIsMenuOpen}) => {
  const [programsDetails, setProgramsDetails] = useState<ProgramsDetails>({
    categoryParentTitle: "",
    categoryTitle: "",
    programsList: [],
  });
  const onCloseHandler =()=>{
    setIsMenuOpen(false);
  }
  return (
    <div
      className={styles.dProgramMenuWrapper}
      style={{ height: `calc(100vh - ${headerHeight}px)` }}
    >
      <div className={styles.dProgramMenu}>
        <DPrograms setProgramsDetails={setProgramsDetails} onCloseHandler={onCloseHandler}/>
        <DProgramListing programsDetails={programsDetails} onCloseHandler={onCloseHandler}/>
        <Close className={styles.dProgramCloser} color={"#1a325d"} onClick={onCloseHandler}/>
      </div>
    </div>
  );
};

export default DesktopProgramMenu;
